module.exports = __webpack_public_path__ + "assets/images/clients/12.png";